export enum ConditionTypes {
  Sku = "SKU",
  Specification = "Specification",
  ProductGroup = "ProductGroup",
  ProductCategory = "ProductCategory",
}

export const conditionTypeOptions = [
  { value: ConditionTypes.Sku, label: "SKU" },
  { value: ConditionTypes.Specification, label: "Specification" },
  { value: ConditionTypes.ProductGroup, label: "Product Group" },
  { value: ConditionTypes.ProductCategory, label: "Product Category" },
];
